import { mapState, mapActions, mapMutations } from 'vuex';

import {
  PERFIS_USUARIO_PESQUISA, PERFIS_USUARIO, ESTADOS, STATUS_CONTA, BANCOS, TIPO_CONTA,
  DIAS_DA_SEMANA, INICIO_WIDGETS
} from '../../util/constantes.js';
import Util from '../../util/funcoes.js';
import GruposPermissoes from './util/gruposPermissoes.js';

import AppGravarContaBancariaDialog from './dialogs/GravarContaBancariaDialog.vue';
import AppFichaUsuarioDialog from './dialogs/FichaUsuarioDialog.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUniversity } from '@fortawesome/free-solid-svg-icons';

library.add(faUniversity)

export default {
  components: {
    AppGravarContaBancariaDialog,
    AppFichaUsuarioDialog,
    FontAwesomeIcon
  },
  data() {
    return {
      infiniteLoadingId: 0,
      tabSelecionada: "detalhes",
      contaBancariaSelecionada: undefined,
      contaBancariaEmEdicao: {},
      visibilidadeGravarContaDialog: false,
      visibilidadeFichaUsuarioDialog: false,
      horarioAcesso: {
        diaDaSemana: "SEGUNDA",
        horarioInicio: undefined,
        horarioFim: undefined
      },
      validacao: {
        login: [
          { required: true, message: "Login é obrigatório" }
        ],
        perfil: [
          { required: true, message: "Perfil é obrigatório" }
        ],
        senha: [
          { required: true, message: "Senha é obrigatório" }
        ],
        confirmacaoSenha: [
          { required: true, message: "Confirmação da senha é obrigatório" }
        ],
        nome: [
          { required: true, message: "Nome é obrigatório" }
        ]
      },

      inputType: 'password',
      inputTypeRepetir: 'password',

      hoverGravar: false,
      hoverRemover: false,
      hoverAtivarDesativar: false,
      hoverGerarFicha: false
    }
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado; },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "USUARIOS" })[0] }
    }),
    ...mapState('usuariosStore', {
      usuarioPesquisa(state) { return state.usuarioPesquisa },
      usuarios(state) { return state.listaUsuarios },
      labelQuantidade(state) { return state.labelQuantidade },
      usuario(state) { return state.usuarioSelecionado },
      usuarioLogin(state) { return state.usuarioSelecionado.login },
      perfisSelect(state) { return state.perfisSelect },

      exibirBotaoGravar(){
        return !((this.usuario.id !== 0 && this.permissoes.alteracao && this.permissoes.alteracaoPermissoes) ||
               (this.usuario.id === 0 && this.permissoes.cadastro))
      }
    }),

    isPassword() {
      return this.inputType === 'password'
    },

    isPasswordRepetir() {
      return this.inputTypeRepetir === 'password'
    },

    isVisibleWidgetAluguel() {
      return this.usuarioLogado.imobiliaria && this.usuarioLogado.imobiliaria.moduloAluguel;
    },
    isVisibleWidgetVenda() {
      return this.usuarioLogado.imobiliaria && this.usuarioLogado.imobiliaria.moduloVenda;
    },
    
    isVisiblePermissoesAluguel() {
      return this.usuarioLogado.imobiliaria && this.usuarioLogado.imobiliaria.moduloAluguel;
    },
    isVisiblePermissoesVenda() {
      return this.usuarioLogado.imobiliaria && this.usuarioLogado.imobiliaria.moduloVenda;
    },
    isVisiblePermissoesFinanceiro() {
      return this.usuarioLogado.imobiliaria && this.usuarioLogado.imobiliaria.moduloFinanceiro;
    },

    moduloPermissoesClientesAluguel() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CLIENTES_ALUGUEL'
        })[0];
    },
    moduloPermissoesImoveisAluguel() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'IMOVEIS_ALUGUEL'
        })[0];
    },
    moduloPermissoesContratosAluguel() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CONTRATOS_ALUGUEL'
        })[0];
    },
    moduloPermissoesRelatoriosClientesAluguel() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_CLIENTES_ALUGUEL'
        })[0];
    },
    moduloPermissoesRelatoriosContratosAluguel() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_CONTRATOS_ALUGUEL'
        })[0];
    },
    moduloPermissoesRelatoriosImoveisAluguel() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_IMOVEIS_ALUGUEL'
        })[0];
    },
    moduloPermissoesRelatoriosPretendentesAluguel() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_PRETENDENTES_ALUGUEL'
        })[0];
    },
    moduloPermissoesRelatoriosFinanceirosAluguel() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_FINANCEIROS_ALUGUEL'
        })[0];
    },
    moduloPermissoesClientesVenda() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CLIENTES_VENDA'
        })[0];
    },
    moduloPermissoesImoveisVenda() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'IMOVEIS_VENDA';
        })[0];
    },
    moduloPermissoesContratosVenda() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CONTRATOS_VENDA'
        })[0];
    },
    moduloPermissoesRelatoriosCaptacoesVenda() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_CAPTACOES_VENDA'
        })[0];
    },
    moduloPermissoesRelatoriosComissoesVenda() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_COMISSOES_VENDA'
        })[0];
    },
    moduloPermissoesRelatoriosClientesVenda() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_CLIENTES_VENDA'
        })[0];
    },
    moduloPermissoesRelatoriosImoveisVenda() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_IMOVEIS_VENDA'
        })[0];
    },
    moduloPermissoesRelatoriosPretendentesVenda() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'RELATORIOS_PRETENDENTES_VENDA'
        })[0];
    },
    moduloPermissoesContasReceber() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CONTAS_RECEBER'
        })[0];
    },
    moduloPermissoesLancamentosContasReceber() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'LANCAMENTOS_CONTAS_RECEBER'
        })[0];
    },
    moduloPermissoesContasPagar() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CONTAS_PAGAR'
        })[0];
    },
    moduloPermissoesLancamentosContasPagar() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'LANCAMENTOS_CONTAS_PAGAR'
        })[0];
    },
    moduloPermissoesCaixa() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CAIXA'
        })[0];
    },
    moduloPermissoesFornecedores() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'FORNECEDORES'
        })[0];
    },
    moduloPermissoesPlanosConta() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'PLANOS_CONTA'
        })[0];
    },
    moduloPermissoesGruposConta() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'GRUPOS_CONTA'
        })[0];
    },
    moduloPermissoesPretendentes() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'PRETENDENTES'
        })[0];
    },
    moduloPermissoesCondominios() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CONDOMINIOS'
        })[0];
    },
    moduloPermissoesAdministradoras() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'ADMINISTRADORAS'
        })[0];
    },
    moduloPermissoesUsuarios() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'USUARIOS'
        })[0];
    },
    moduloPermissoesPerfisUsuarios() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'PERFIS_USUARIOS'
        })[0];
    },
    moduloPermissoesPlacas() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'PLACAS'
        })[0];
    },
    moduloPermissoesContasBancarias() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'CONTAS_BANCARIAS'
        })[0];
    },
    moduloPermissoesPortais() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'PORTAIS'
        })[0];
    },
    moduloPermissoesLogs() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'LOGS'
        })[0];
    },
    moduloPermissoesVisita() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'VISITA'
        })[0];
    },
    moduloPermissoesSistema() {
      return this.usuario.permissoes
        .filter((permissao) => {
          return permissao.modulo === 'SISTEMA'
        })[0];
    },
    
    grupoAluguelClientes() { return GruposPermissoes.ALUGUEL_CLIENTES },
    grupoAluguelClientesCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoAluguelClientesCheckAll },
      set(value) { this.setGrupoAluguelClientesCheckAll(value) }
    },
    grupoAluguelClientesChecklist: {
      get() { return this.$store.state.usuariosStore.grupoAluguelClientesChecklist },
      set(value) { this.setGrupoAluguelClientesChecklist(value) }
    },

    grupoAluguelBaixa() { return GruposPermissoes.ALUGUEL_BAIXA },
    grupoAluguelBaixaCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoAluguelBaixaCheckAll },
      set(value) { this.setGrupoAluguelBaixaCheckAll(value) }
    },
    grupoAluguelBaixaChecklist: {
      get() { return this.$store.state.usuariosStore.grupoAluguelBaixaChecklist },
      set(value) { this.setGrupoAluguelBaixaChecklist(value) }
    },

    grupoAluguelLiberacaoRepasse() { return GruposPermissoes.ALUGUEL_LIBERACAO_REPASSE },
    grupoAluguelLiberacaoRepasseCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoAluguelLiberacaoRepasseCheckAll },
      set(value) { this.setGrupoAluguelLiberacaoRepasseCheckAll(value) }
    },
    grupoAluguelLiberacaoRepasseChecklist: {
      get() { return this.$store.state.usuariosStore.grupoAluguelLiberacaoRepasseChecklist },
      set(value) { this.setGrupoAluguelLiberacaoRepasseChecklist(value) }
    },

    grupoAluguelImoveis() { return GruposPermissoes.ALUGUEL_IMOVEIS },
    grupoAluguelImoveisCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoAluguelImoveisCheckAll },
      set(value) { this.setGrupoAluguelImoveisCheckAll(value) }
    },
    grupoAluguelImoveisChecklist : {
      get() { return this.$store.state.usuariosStore.grupoAluguelImoveisChecklist },
      set(value) { this.setGrupoAluguelImoveisChecklist(value) }
    },

    grupoAluguelContratos() { return GruposPermissoes.ALUGUEL_CONTRATOS },
    grupoAluguelContratosCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoAluguelContratosCheckAll },
      set(value) { this.setGrupoAluguelContratosCheckAll(value) }
    },
    grupoAluguelContratosChecklist: {
      get() { return this.$store.state.usuariosStore.grupoAluguelContratosChecklist },
      set(value) { this.setGrupoAluguelContratosChecklist(value) }
    },

    grupoAluguelReajuste() { return GruposPermissoes.ALUGUEL_REAJUSTE },
    grupoAluguelReajusteCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoAluguelReajusteCheckAll },
      set(value) { this.setGrupoAluguelReajusteCheckAll(value) }
    },
    grupoAluguelReajusteChecklist: {
      get() { return this.$store.state.usuariosStore.grupoAluguelReajusteChecklist },
      set(value) { this.setGrupoAluguelReajusteChecklist(value) }
    },

    grupoAluguelVencimento() { return GruposPermissoes.ALUGUEL_VENCIMENTO },
    grupoAluguelVencimentoCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoAluguelVencimentoCheckAll },
      set(value) { this.setGrupoAluguelVencimentoCheckAll(value) }
    },
    grupoAluguelVencimentoChecklist: {
      get() { return this.$store.state.usuariosStore.grupoAluguelVencimentoChecklist },
      set(value) { this.setGrupoAluguelVencimentoChecklist(value) }
    },

    grupoRelatoriosClientesChecklist: {
      get() { return this.$store.state.usuariosStore.grupoRelatoriosClientesChecklist },
      set(value) { this.setGrupoRelatoriosClientesChecklist(value) }
    },

    grupoRelatoriosContratos() { return GruposPermissoes.RELATORIOS_CONTRATOS },
    grupoRelatoriosContratosCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoRelatoriosContratosCheckAll },
      set(value) { this.setGrupoRelatoriosContratosCheckAll(value) }
    },
    grupoRelatoriosContratosChecklist: {
      get() { return this.$store.state.usuariosStore.grupoRelatoriosContratosChecklist },
      set(value) { this.setGrupoRelatoriosContratosChecklist(value) }
    },

    grupoRelatoriosImoveis() { return GruposPermissoes.RELATORIOS_IMOVEIS },
    grupoRelatoriosImoveisCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoRelatoriosImoveisCheckAll },
      set(value) { this.setGrupoRelatoriosImoveisCheckAll(value) }
    },
    grupoRelatoriosImoveisChecklist: {
      get() { return this.$store.state.usuariosStore.grupoRelatoriosImoveisChecklist },
      set(value) { this.setGrupoRelatoriosImoveisChecklist(value) }
    },

    grupoRelatoriosPretendentesChecklist: {
      get() { return this.$store.state.usuariosStore.grupoRelatoriosPretendentesChecklist },
      set(value) { this.setGrupoRelatoriosPretendentesChecklist(value) }
    },

    grupoRelatoriosFinanceiros() { return GruposPermissoes.RELATORIOS_FINANCEIROS },
    grupoRelatoriosFinanceirosCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoRelatoriosFinanceirosCheckAll },
      set(value) { this.setGrupoRelatoriosFinanceirosCheckAll(value) }
    },
    grupoRelatoriosFinanceirosChecklist: {
      get() { return this.$store.state.usuariosStore.grupoRelatoriosFinanceirosChecklist },
      set(value) { this.setGrupoRelatoriosFinanceirosChecklist(value) }
    },

    grupoVendaClientes() { return GruposPermissoes.VENDA_CLIENTES },
    grupoVendaClientesCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoVendaClientesCheckAll },
      set(value) { this.setGrupoVendaClientesCheckAll(value) }
    },
    grupoVendaClientesChecklist: {
      get() { return this.$store.state.usuariosStore.grupoVendaClientesChecklist },
      set(value) { this.setGrupoVendaClientesChecklist(value) }
    },

    grupoVendaImoveis() { return GruposPermissoes.VENDA_IMOVEIS },
    grupoVendaImoveisCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoVendaImoveisCheckAll },
      set(value) { this.setGrupoVendaImoveisCheckAll(value) }
    },
    grupoVendaImoveisChecklist: {
      get() { return this.$store.state.usuariosStore.grupoVendaImoveisChecklist },
      set(value) { this.setGrupoVendaImoveisChecklist(value) }
    },

    grupoVendaContratos() { return GruposPermissoes.VENDA_CONTRATOS },
    grupoVendaContratosCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoVendaContratosCheckAll },
      set(value) { this.setGrupoVendaContratosCheckAll(value) }
    },
    grupoVendaContratosChecklist: {
      get() { return this.$store.state.usuariosStore.grupoVendaContratosChecklist },
      set(value) { this.setGrupoVendaContratosChecklist(value) }
    },

    grupoVendaRelatorios() { return GruposPermissoes.VENDA_RELATORIOS },
    grupoVendaRelatoriosCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoVendaRelatoriosCheckAll },
      set(value) { this.setGrupoVendaRelatoriosCheckAll(value) }
    },
    grupoVendaRelatoriosChecklist: {
      get() { return this.$store.state.usuariosStore.grupoVendaRelatoriosChecklist },
      set(value) { this.setGrupoVendaRelatoriosChecklist(value) }
    },

    grupoFinanceiroContasReceber() { return GruposPermissoes.FINANCEIRO_CONTAS_RECEBER },
    grupoFinanceiroContasReceberCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroContasReceberCheckAll },
      set(value) { this.setGrupoFinanceiroContasReceberCheckAll(value) }
    },
    grupoFinanceiroContasReceberChecklist: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroContasReceberChecklist },
      set(value) { this.setGrupoFinanceiroContasReceberChecklist(value) }
    },

    grupoFinanceiroLancamentosReceber() { return GruposPermissoes.FINANCEIRO_LANCAMENTOS_RECEBER },
    grupoFinanceiroLancamentosReceberCheckAll: {
      get() { return this.$store.state.grupoFinanceiroLancamentosReceberCheckAll },
      set(value) { this.setGrupoFinanceiroLancamentosReceberCheckAll(value) }
    },
    grupoFinanceiroLancamentosReceberChecklist: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroLancamentosReceberChecklist },
      set(value) { this.setGrupoFinanceiroLancamentosReceberChecklist(value) }
    },

    grupoFinanceiroContasPagar() { return GruposPermissoes.FINANCEIRO_CONTAS_PAGAR },
    grupoFinanceiroContasPagarCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroContasPagarCheckAll },
      set(value) { this.setGrupoFinanceiroContasPagarCheckAll(value) }
    },
    grupoFinanceiroContasPagarChecklist: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroContasPagarChecklist },
      set(value) { this.setGrupoFinanceiroContasPagarChecklist(value) }
    },

    grupoFinanceiroLancamentosPagar() { return GruposPermissoes.FINANCEIRO_LANCAMENTOS_PAGAR },
    grupoFinanceiroLancamentosPagarCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroLancamentosPagarCheckAll },
      set(value) { this.setGrupoFinanceiroLancamentosPagarCheckAll(value) }
    },
    grupoFinanceiroLancamentosPagarChecklist: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroLancamentosPagarChecklist },
      set(value) { this.setGrupoFinanceiroLancamentosPagarChecklist(value) }
    },

    grupoFinanceiroCaixa() { return GruposPermissoes.FINANCEIRO_CAIXA },
    grupoFinanceiroCaixaCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroCaixaCheckAll },
      set(value) { this.setGrupoFinanceiroCaixaCheckAll(value) }
    },
    grupoFinanceiroCaixaChecklist: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroCaixaChecklist },
      set(value) { this.setGrupoFinanceiroCaixaChecklist(value) }
    },

    grupoFinanceiroFornecedores() { return GruposPermissoes.FINANCEIRO_FORNECEDORES },
    grupoFinanceiroFornecedoresCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroFornecedoresCheckAll },
      set(value) { this.setGrupoFinanceiroFornecedoresCheckAll(value) }
    },
    grupoFinanceiroFornecedoresChecklist: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroFornecedoresChecklist },
      set(value) { this.setGrupoFinanceiroFornecedoresChecklist(value) }
    },

    grupoFinanceiroPlanosConta() { return GruposPermissoes.FINANCEIRO_PLANOS_CONTA },
    grupoFinanceiroPlanosContaCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroPlanosContaCheckAll },
      set(value) { this.setGrupoFinanceiroPlanosContaCheckAll(value) }
    },
    grupoFinanceiroPlanosContaChecklist: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroPlanosContaChecklist },
      set(value) { this.setGrupoFinanceiroPlanosContaChecklist(value) }
    },

    grupoFinanceiroGruposConta() { return GruposPermissoes.FINANCEIRO_GRUPOS_CONTA },
    grupoFinanceiroGruposContaCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroGruposContaCheckAll },
      set(value) { this.setGrupoFinanceiroGruposContaCheckAll(value) }
    },
    grupoFinanceiroGruposContaChecklist: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroGruposContaChecklist },
      set(value) { this.setGrupoFinanceiroGruposContaChecklist(value) }
    },

    grupoFinanceiroRelatorios() { return GruposPermissoes.FINANCEIRO_RELATORIOS },
    grupoFinanceiroRelatoriosCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroRelatoriosCheckAll },
      set(value) { this.setGrupoFinanceiroRelatoriosCheckAll(value) },
    },
    grupoFinanceiroRelatoriosChecklist: {
      get() { return this.$store.state.usuariosStore.grupoFinanceiroRelatoriosChecklist },
      set(value) { this.setGrupoFinanceiroRelatoriosChecklist(value) },
    },

    grupoConfiguracoesPretendentes() { return GruposPermissoes.CONFIGURACOES_PRETENDENTES },
    grupoConfiguracoesPretendentesCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesPretendentesCheckAll },
      set(value) { this.setGrupoConfiguracoesPretendentesCheckAll(value) }
    },
    grupoConfiguracoesPretendentesChecklist: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesPretendentesChecklist },
      set(value) { this.setGrupoConfiguracoesPretendentesChecklist(value) }
    },

    grupoConfiguracoesCondominios() { return GruposPermissoes.CONFIGURACOES_CONDOMINIOS },
    grupoConfiguracoesCondominiosCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesCondominiosCheckAll },
      set(value) { this.setGrupoConfiguracoesCondominiosCheckAll(value) }
    },
    grupoConfiguracoesCondominiosChecklist: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesCondominiosChecklist },
      set(value) { this.setGrupoConfiguracoesCondominiosChecklist(value) }
    },

    grupoConfiguracoesAdministradoras() { return GruposPermissoes.CONFIGURACOES_ADMINISTRADORAS },
    grupoConfiguracoesAdministradorasCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesAdministradorasCheckAll },
      set(value) { this.setGrupoConfiguracoesAdministradorasCheckAll(value) }
    },
    grupoConfiguracoesAdministradorasChecklist: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesAdministradorasChecklist },
      set(value) { this.setGrupoConfiguracoesAdministradorasChecklist(value) }
    },

    grupoConfiguracoesUsuarios() { return GruposPermissoes.CONFIGURACOES_USUARIOS },
    grupoConfiguracoesUsuariosCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesUsuariosCheckAll },
      set(value) { this.setGrupoConfiguracoesUsuariosCheckAll(value) }
    },
    grupoConfiguracoesUsuariosChecklist: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesUsuariosChecklist },
      set(value) { this.setGrupoConfiguracoesUsuariosChecklist(value) }
    },

    grupoConfiguracoesPerfis() { return GruposPermissoes.CONFIGURACOES_PERFIS },
    grupoConfiguracoesPerfisChecklist: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesPerfisChecklist },
      set(value) { this.setGrupoConfiguracoesPerfisChecklist(value) }
    },
    grupoConfiguracoesPerfisCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesPerfisCheckAll },
      set(value) { this.setGrupoConfiguracoesPerfisCheckAll(value) }
    },

    grupoConfiguracoesPlacas() { return GruposPermissoes.CONFIGURACOES_PLACAS },
    grupoConfiguracoesPlacasCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesPlacasCheckAll },
      set(value) { this.setGrupoConfiguracoesPlacasCheckAll(value) }
    },
    grupoConfiguracoesPlacasChecklist: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesPlacasChecklist },
      set(value) { this.setGrupoConfiguracoesPlacasChecklist(value) }
    },

    grupoConfiguracoesContas() { return GruposPermissoes.CONFIGURACOES_CONTAS },
    grupoConfiguracoesContasChecklist: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesContasChecklist },
      set(value) { this.setGrupoConfiguracoesContasChecklist(value) }
    },
    grupoConfiguracoesContasCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesContasCheckAll },
      set(value) { this.setGrupoConfiguracoesContasCheckAll(value) }
    },

    grupoConfiguracoesPortais() { return GruposPermissoes.CONFIGURACOES_PORTAIS },
    grupoConfiguracoesPortaisCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesPortaisCheckAll },
      set(value) { this.setGrupoConfiguracoesPortaisCheckAll(value) }
    },
    grupoConfiguracoesPortaisChecklist: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesPortaisChecklist },
      set(value) { this.setGrupoConfiguracoesPortaisChecklist(value) }
    },

    grupoConfiguracoesLogs() { return GruposPermissoes.CONFIGURACOES_LOGS },
    grupoConfiguracoesLogsCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesLogsCheckAll },
      set(value) { this.setGrupoConfiguracoesLogsCheckAll(value) }
    },
    grupoConfiguracoesLogsChecklist: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesLogsChecklist },
      set(value) { this.setGrupoConfiguracoesLogsChecklist(value) }
    },

    grupoConfiguracoesVisitas() { return GruposPermissoes.CONFIGURACOES_VISITAS },
    grupoConfiguracoesVisitasCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesVisitasCheckAll },
      set(value) { this.setGrupoConfiguracoesVisitasCheckAll(value) }
    },
    grupoConfiguracoesVisitasChecklist: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesVisitasChecklist },
      set(value) { this.setGrupoConfiguracoesVisitasChecklist(value) }
    },

    grupoConfiguracoesSistema() { return GruposPermissoes.CONFIGURACOES_SISTEMA },
    grupoConfiguracoesSistemaCheckAll: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesSistemaCheckAll },
      set(value) { this.setGrupoConfiguracoesSistemaCheckAll(value) }
    },
    grupoConfiguracoesSistemaChecklist: {
      get() { return this.$store.state.usuariosStore.grupoConfiguracoesSistemaChecklist },
      set(value) { this.setGrupoConfiguracoesSistemaChecklist(value) }
    },

    perfilSelecionado: {
      get() { return this.$store.state.usuariosStore.perfilSelecionado },
      set(value) { this.setPerfilSelecionado(value) }
    },
    perfisUsuarioPesquisa() { return PERFIS_USUARIO_PESQUISA },
    perfisUsuario() { return PERFIS_USUARIO },
    estados() { return ESTADOS },
    novoUsuario() { return this.usuario.id === 0 },
    exibirBotaoRemoverUsuario() { return this.usuario.id !== 0 },
    exibirBotaoGerarFicha() { return this.usuario.id !== 0 },
    exibirBotaoAtivarDesativarUsuario() { return this.usuario.id !== 0 },
    exibirLabelAtivoInativo() { return this.usuario.id !== 0 },
    util() { return Util },
    statusConta() { return STATUS_CONTA },
    bancos() { return BANCOS },
    tiposConta() { return TIPO_CONTA },
    diasSemana() { return DIAS_DA_SEMANA },
    opcoesWigetsInicial(){ return INICIO_WIDGETS },
    isCampoSuperUsuarioVisible() {
      //return this.usuarioLogado.perfil === 'ADMINISTRADOR';
      return false;
    },
    usuarioInativo(){
      return this.usuario.inativo;
    }
  },
  watch: {
    usuarioLogin(value) {
      this.usuario.cpf = value;
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapMutations('usuariosStore', [
      'setPerfilSelecionado',
      'atualizarPermissoesUsuarioSelecionado',
      'atualizarWidgetsUsuarioSelecionado',
      'limparPermissoesEWidgetsUsuarioSelecionado',

      'setGrupoAluguelClientesCheckAll',
      'setGrupoAluguelClientesChecklist',

      'setGrupoAluguelBaixaCheckAll',
      'setGrupoAluguelBaixaChecklist',

      'setGrupoAluguelLiberacaoRepasseCheckAll',
      'setGrupoAluguelLiberacaoRepasseChecklist',

      'setGrupoAluguelImoveisCheckAll',
      'setGrupoAluguelImoveisChecklist',

      'setGrupoAluguelContratosCheckAll',
      'setGrupoAluguelContratosChecklist',

      'setGrupoAluguelReajusteCheckAll',
      'setGrupoAluguelReajusteChecklist',

      'setGrupoAluguelVencimentoCheckAll',
      'setGrupoAluguelVencimentoChecklist',

      'setGrupoRelatoriosClientesChecklist',

      'setGrupoRelatoriosContratosCheckAll',
      'setGrupoRelatoriosContratosChecklist',

      'setGrupoRelatoriosImoveisCheckAll',
      'setGrupoRelatoriosImoveisChecklist',

      'setGrupoRelatoriosPretendentesChecklist',

      'setGrupoRelatoriosFinanceirosCheckAll',
      'setGrupoRelatoriosFinanceirosChecklist',

      'setGrupoVendaClientesCheckAll',
      'setGrupoVendaClientesChecklist',

      'setGrupoVendaImoveisCheckAll',
      'setGrupoVendaImoveisChecklist',

      'setGrupoVendaContratosCheckAll',
      'setGrupoVendaContratosChecklist',

      'setGrupoVendaRelatoriosCheckAll',
      'setGrupoVendaRelatoriosChecklist',

      'setGrupoFinanceiroContasReceberCheckAll',
      'setGrupoFinanceiroContasReceberChecklist',

      'setGrupoFinanceiroLancamentosReceberCheckAll',
      'setGrupoFinanceiroLancamentosReceberChecklist',

      'setGrupoFinanceiroContasPagarCheckAll',
      'setGrupoFinanceiroContasPagarChecklist',

      'setGrupoFinanceiroLancamentosPagarCheckAll',
      'setGrupoFinanceiroLancamentosPagarChecklist',

      'setGrupoFinanceiroCaixaCheckAll',
      'setGrupoFinanceiroCaixaChecklist',

      'setGrupoFinanceiroFornecedoresCheckAll',
      'setGrupoFinanceiroFornecedoresChecklist',

      'setGrupoFinanceiroPlanosContaCheckAll',
      'setGrupoFinanceiroPlanosContaChecklist',

      'setGrupoFinanceiroGruposContaCheckAll',
      'setGrupoFinanceiroGruposContaChecklist',

      'setGrupoFinanceiroRelatoriosCheckAll',
      'setGrupoFinanceiroRelatoriosChecklist',

      'setGrupoConfiguracoesPretendentesCheckAll',
      'setGrupoConfiguracoesPretendentesChecklist',

      'setGrupoConfiguracoesCondominiosCheckAll',
      'setGrupoConfiguracoesCondominiosChecklist',

      'setGrupoConfiguracoesAdministradorasCheckAll',
      'setGrupoConfiguracoesAdministradorasChecklist',

      'setGrupoConfiguracoesUsuariosCheckAll',
      'setGrupoConfiguracoesUsuariosChecklist',

      'setGrupoConfiguracoesPerfisCheckAll',
      'setGrupoConfiguracoesPerfisChecklist',

      'setGrupoConfiguracoesPlacasCheckAll',
      'setGrupoConfiguracoesPlacasChecklist',

      'setGrupoConfiguracoesContasCheckAll',
      'setGrupoConfiguracoesContasChecklist',

      'setGrupoConfiguracoesPortaisCheckAll',
      'setGrupoConfiguracoesPortaisChecklist',

      'setGrupoConfiguracoesLogsCheckAll',
      'setGrupoConfiguracoesLogsChecklist',

      'setGrupoConfiguracoesVisitasCheckAll',
      'setGrupoConfiguracoesVisitasChecklist',

      'setGrupoConfiguracoesSistemaCheckAll',
      'setGrupoConfiguracoesSistemaChecklist'
    ]),
    ...mapActions('usuariosStore', [
      'listarUsuarios',
      'limparUsuariosListados',
      'limparUsuarioPesquisa',
      'recuperarUsuario',
      'limparUsuarioSelecionado',
      'gravarUsuario',
      'removerUsuario',
      'removerConta',
      'reativarUsuario',
      'ativarUsuario',
      'desativarUsuario',
      'listarPerfis'
    ]),
    fecharGravarContaDialog() {
      this.visibilidadeGravarContaDialog = false;
    },
    exibirGravarContaDialog() {
      this.contaBancariaEmEdicao = undefined;
      this.visibilidadeGravarContaDialog = true;
    },
    editarContaBancaria(contaBancaria) {
      this.contaBancariaEmEdicao = Object.assign({}, contaBancaria);
      this.visibilidadeGravarContaDialog = true;
    },
    fecharFichaUsuarioDialog() {
      this.visibilidadeFichaUsuarioDialog = false;
    },
    exibirFichaUsuarioDialog() {
      this.visibilidadeFichaUsuarioDialog = true;
    },
    pesquisar($state) {
      if(this.usuarioPesquisa.pagina === 0) { this.showLoading() }
      this.listarUsuarios(this.usuarioPesquisa)
        .then((resultado) => {
          if(this.usuarioPesquisa.pagina === 0) { this.hideLoading() }
          if(resultado.lista.length === 100) {
            this.usuarioPesquisa.pagina += 1;
            $state.loaded();
          } else if(resultado.lista.length > 0 && this.usuarioPesquisa.pagina === 0) {
            $state.loaded();
            $state.complete();
          } else {
            $state.complete();
          }
        }).catch(() => {
          if(this.usuarioPesquisa.pagina === 0) { this.hideLoading() }
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },

    setVisibilidadeSenha() {
      this.inputType = this.isPassword ? 'text' : 'password'
    },

    setVisibilidadeRepetirSenha() {
      this.inputTypeRepetir = this.isPasswordRepetir ? 'text' : 'password'
    },

    handlePerfilSelecionadoChange(perfil) {
      if(perfil) {
        this.atualizarPermissoesUsuarioSelecionado(perfil);
        this.atualizarWidgetsUsuarioSelecionado(perfil);
      }
    },

    handleGrupoAluguelClientesCheckAllChange(checked) {
      this.setGrupoAluguelClientesChecklist(checked ? GruposPermissoes.ALUGUEL_CLIENTES_CHECK_ALL : []);
    },
    handleGrupoAluguelBaixaCheckAllChange(checked) {
      this.setGrupoAluguelBaixaChecklist(checked ? GruposPermissoes.ALUGUEL_BAIXA_CHECK_ALL : []);
    },
    handleGrupoAluguelLiberacaoRepasseCheckAllChange(checked) {
      this.setGrupoAluguelLiberacaoRepasseChecklist(checked ? GruposPermissoes.ALUGUEL_LIBERACAO_REPASSE_CHECK_ALL : []);
    },
    handleGrupoAluguelImoveisCheckAllChange(checked) {
      this.setGrupoAluguelImoveisChecklist(checked ? GruposPermissoes.ALUGUEL_IMOVEIS_CHECK_ALL : []);
    },
    handleGrupoAluguelContratosCheckAllChange(checked) {
      this.setGrupoAluguelContratosChecklist(checked ? GruposPermissoes.ALUGUEL_CONTRATOS_CHECK_ALL : []);
    },
    handleGrupoAluguelReajusteCheckAllChange(checked) {
      this.setGrupoAluguelReajusteChecklist(checked ? GruposPermissoes.ALUGUEL_REAJUSTE_CHECK_ALL : []);
    },
    handleGrupoAluguelVencimentoCheckAllChange(checked) {
      this.setGrupoAluguelVencimentoChecklist(checked ? GruposPermissoes.ALUGUEL_VENCIMENTO_CHECK_ALL : []);
    },
    handleGrupoRelatoriosContratosCheckAllChange(checked) {
      this.setGrupoRelatoriosContratosChecklist(checked ? GruposPermissoes.RELATORIOS_CONTRATOS_CHECK_ALL : []);
    },
    handleGrupoRelatoriosImoveisCheckAllChange(checked) {
      this.setGrupoRelatoriosImoveisChecklist(checked ? GruposPermissoes.RELATORIOS_IMOVEIS_CHECK_ALL : []);
    },
    handleGrupoRelatoriosFinanceirosCheckAllChange(checked) {
      this.setGrupoRelatoriosFinanceirosChecklist(checked ? GruposPermissoes.RELATORIOS_FINANCEIROS_CHECK_ALL : []);
    },
    handleGrupoVendaClientesCheckAllChange(checked) {
      this.setGrupoVendaClientesChecklist(checked ? GruposPermissoes.VENDA_CLIENTES_CHECK_ALL : []);
    },
    handleGrupoVendaImoveisCheckAllChange(checked) {
      this.setGrupoVendaImoveisChecklist(checked ? GruposPermissoes.VENDA_IMOVEIS_CHECK_ALL : []);
    },
    handleGrupoVendaContratosCheckAllChange(checked) {
      this.setGrupoVendaContratosChecklist(checked ? GruposPermissoes.VENDA_CONTRATOS_CHECK_ALL : []);
    },
    handleGrupoVendaRelatoriosCheckAllChange(checked) {
      this.setGrupoVendaRelatoriosChecklist(checked ? GruposPermissoes.VENDA_RELATORIOS_CHECK_ALL : []);
    },
    handleGrupoFinanceiroContasReceberCheckAllChange(checked) {
      this.setGrupoFinanceiroContasReceberChecklist(checked ? GruposPermissoes.FINANCEIRO_CONTAS_RECEBER_CHECK_ALL : []);
    },
    handleGrupoFinanceiroLancamentosReceberCheckAllChange(checked) {
      this.setGrupoFinanceiroLancamentosReceberChecklist(checked ? GruposPermissoes.FINANCEIRO_LANCAMENTOS_RECEBER_CHECK_ALL : []);
    },
    handleGrupoFinanceiroContasPagarCheckAllChange(checked) {
      this.setGrupoFinanceiroContasPagarChecklist(checked ? GruposPermissoes.FINANCEIRO_CONTAS_PAGAR_CHECK_ALL : []);
    },
    handleGrupoFinanceiroLancamentosPagarCheckAllChange(checked) {
      this.setGrupoFinanceiroLancamentosPagarChecklist(checked ? GruposPermissoes.FINANCEIRO_LANCAMENTOS_PAGAR_CHECK_ALL : []);
    },
    handleGrupoFinanceiroCaixaCheckAllChange(checked) {
      this.setGrupoFinanceiroCaixaChecklist(checked ? GruposPermissoes.FINANCEIRO_CAIXA_CHECK_ALL : []);
    },
    handleGrupoFinanceiroFornecedoresCheckAllChange(checked) {
      this.setGrupoFinanceiroFornecedoresChecklist(checked ? GruposPermissoes.FINANCEIRO_FORNECEDORES_CHECK_ALL : []);
    },
    handleGrupoFinanceiroPlanosContaCheckAllChange(checked) {
      this.setGrupoFinanceiroPlanosContaChecklist(checked ? GruposPermissoes.FINANCEIRO_PLANOS_CONTA_CHECK_ALL : []);
    },
    handleGrupoFinanceiroGruposContaCheckAllChange(checked) {
      this.setGrupoFinanceiroGruposContaChecklist(checked ? GruposPermissoes.FINANCEIRO_GRUPOS_CONTA_CHECK_ALL : []);
    },
    handleGrupoFinanceiroRelatoriosCheckAllChange(checked) {
      this.setGrupoFinanceiroRelatoriosChecklist(checked ? GruposPermissoes.FINANCEIRO_RELATORIOS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesPretendentesCheckAllChange(checked) {
      this.setGrupoConfiguracoesPretendentesChecklist(checked ? GruposPermissoes.CONFIGURACOES_PRETENDENTES_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesCondominiosCheckAllChange(checked) {
      this.setGrupoConfiguracoesCondominiosChecklist(checked ? GruposPermissoes.CONFIGURACOES_CONDOMINIOS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesAdministradorasCheckAllChange(checked) {
      this.setGrupoConfiguracoesAdministradorasChecklist(checked ? GruposPermissoes.CONFIGURACOES_ADMINISTRADORAS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesUsuariosCheckAllChange(checked) {
      this.setGrupoConfiguracoesUsuariosChecklist(checked ? GruposPermissoes.CONFIGURACOES_USUARIOS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesPerfisCheckAllChange(checked) {
      this.setGrupoConfiguracoesPerfisChecklist(checked ? GruposPermissoes.CONFIGURACOES_PERFIS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesPlacasCheckAllChange(checked) {
      this.setGrupoConfiguracoesPlacasChecklist(checked ? GruposPermissoes.CONFIGURACOES_PLACAS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesContasCheckAllChange(checked) {
      this.setGrupoConfiguracoesContasChecklist(checked ? GruposPermissoes.CONFIGURACOES_CONTAS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesPortaisCheckAllChange(checked) {
      this.setGrupoConfiguracoesPortaisChecklist(checked ? GruposPermissoes.CONFIGURACOES_PORTAIS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesLogsCheckAllChange(checked) {
      this.setGrupoConfiguracoesLogsChecklist(checked ? GruposPermissoes.CONFIGURACOES_LOGS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesVisitasCheckAllChange(checked) {
      this.setGrupoConfiguracoesVisitasChecklist(checked ? GruposPermissoes.CONFIGURACOES_VISITAS_CHECK_ALL : []);
    },
    handleGrupoConfiguracoesSistemaCheckAllChange(checked) {
      this.setGrupoConfiguracoesSistemaChecklist(checked ? GruposPermissoes.CONFIGURACOES_SISTEMA_CHECK_ALL : []);
    },
    
    dispararPesquisa() {
      this.usuarioPesquisa.pagina = 0;
      this.limparUsuariosListados();
      this.infiniteLoadingId += 1;
    },
    pesquisarHandler() {
      this.dispararPesquisa();
    },
    limparPesquisaHandler() {
      this.limparUsuarioPesquisa();
    },
    limparCamposHorarioAcesso() {
      this.horarioAcesso = {
        diaDaSemana: "SEGUNDA",
        horarioInicio: undefined,
        horarioFim: undefined
      };
    },
    recuperarHandler(usuario) {
      this.recuperar(usuario);
    },
    recuperar(usuario) {
      this.showLoading();
      this.recuperarUsuario(usuario)
        .then(() => {
          this.hideLoading();
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    novoUsuarioHandler() {
      if(this.tabSelecionada === "contas") {
        this.tabSelecionada = "detalhes";
      }
      this.$refs["form"].resetFields();
      this.limparCamposHorarioAcesso();
      this.limparUsuarioSelecionado();
    },
    senhasConferem() {
      return this.usuario.senha === this.usuario.confirmacaoSenha;
    },

    gravar() {
      this.showLoading();

      this.usuario.confirmacaoSenha = undefined;

      this.gravarUsuario(this.usuario)
        .then(this.handleResultadoGravarUsuario)
        .catch(() => {
          this.$message.error('Não foi possível conectar-se ao servidor');
        }).finally(() => {
          this.hideLoading();
        });
    },

    handleResultadoGravarUsuario(resultado) {
      switch(resultado.status) {
        case 'ERRO':
          this.$message.error(resultado.mensagem);
          break;

        case 'FALHA':
          this.handleFalhaGravarUsuario(resultado);
          break;
          
        case 'SUCESSO':
          this.dispararPesquisa();
          this.$message.success(resultado.mensagem);
      }
    },

    handleFalhaGravarUsuario(resultado) {
      switch (resultado.mensagem) {
        case 'ReativarUsuario':
          this.reativarUsuarioHandler();
          break;
      
        case 'LoginJaCadastrado': {
          const usuarioJaCadastrado = { ...resultado.item };
          const perfilUsuarioJaCadastrado = this.getLabelPerfilUsuario(usuarioJaCadastrado.perfil);
          const mensagem = `Este Login já está cadastrado como ${perfilUsuarioJaCadastrado}.`;
          
          this.exibirAlert('Atenção', mensagem, 'error');
          break;
        }

        default:
          this.exibirAlert('Atenção', resultado.mensagem, 'error');
      }
    },

    reativarUsuarioHandler() {
      this.$confirm("O usuário cadastrado com este CPF foi removido anteriormente, deseja reativá-lo?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "info"
      }).then(() => {
        this.showLoading();
        this.reativarUsuario(this.usuario).then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
            case "SUCESSO":
              this.dispararPesquisa();
              this.$message.success(resultado.mensagem);
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
      }).catch(() => {});
    },
    ativarDesativarUsuarioHandler() {
      this.$confirm(
        `Confirma a ${this.usuario.inativo ? 'ativação' : 'desativação'} deste usuário?`,
        'Atenção',
        { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
      ).then(() => {
        if(this.usuario.inativo) {
          this.showLoading();
          this.ativarUsuario(this.usuario).then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                break;
              case "ERRO":
                this.$message.error(resultado.mensagem);
            }
          }).catch(() => {
            this.hideLoading();
            this.$message.error("Não foi possível conectar-se ao servidor");
          });
        } else {
          this.showLoading();
          this.desativarUsuario(this.usuario).then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                break;
              case "ERRO":
                this.$message.error(resultado.mensagem);
            }
          }).catch(() => {
            this.hideLoading();
            this.$message.error("Não foi possível conectar-se ao servidor");
          });
        }
      }).catch(() => {});
    },
    exibirAlert(titulo, mensagem, type='warning') {
      this.$alert(mensagem, titulo, {
        confirmButtonText: 'OK',
        type,
      });
    },
    gravarUsuarioHandler() {
      this.$refs['form'].validate((valid) => {
        if(this.novoUsuario) {
          if(valid) {
            if(!this.senhasConferem()) {
              this.$message.warning("A senha e a confirmação não conferem");
              return;
            }
            this.preencherPermissoes();
            this.gravar();
          } else {
            this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
          }
        } else {
          if(this.usuario.login && this.usuario.perfil && this.usuario.nome) {
            if(this.usuario.senha) {
              if(!this.senhasConferem()) {
                this.$message.warning("A senha e a confirmação não conferem");
                return;
              }
            }
            this.preencherPermissoes();
            this.gravar();
          } else {
            this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
          }
        }
      });
    },

    preencherPermissoes() {
      this.preencherPermissoesGrupoAluguelClientes();
      this.preencherPermissoesGrupoAluguelBaixa();
      this.preencherPermissoesGrupoAluguelLiberacaoRepasse();
      this.preencherPermissoesGrupoAluguelImoveis();
      this.preencherPermissoesGrupoAluguelContratos();
      this.preencherPermissoesGrupoAluguelReajuste();
      this.preencherPermissoesGrupoAluguelVencimento();
      this.preencherPermissoesGrupoRelatoriosClientes();
      this.preencherPermissoesGrupoRelatoriosContratos();
      this.preencherPermissoesGrupoRelatoriosImoveis();
      this.preencherPermissoesGrupoRelatoriosPretendentes();
      this.preencherPermissoesGrupoRelatoriosFinanceiros();
      this.preencherPermissoesGrupoVendaClientes();
      this.preencherPermissoesGrupoVendaImoveis();
      this.preencherPermissoesGrupoVendaContratos();
      this.preencherPermissoesGrupoVendaRelatorios();
      this.preencherPermissoesGrupoFinanceiroContasReceber();
      this.preencherPermissoesGrupoFinanceiroLancamentosReceber();
      this.preencherPermissoesGrupoFinanceiroContasPagar();
      this.preencherPermissoesGrupoFinanceiroLancamentosPagar();
      this.preencherPermissoesGrupoFinanceiroCaixa();
      this.preencherPermissoesGrupoFinanceiroFornecedores();
      this.preencherPermissoesGrupoFinanceiroPlanosConta();
      this.preencherPermissoesGrupoFinanceiroGruposConta();
      this.preencherPermissoesGrupoFinanceiroRelatorios();
      this.preencherPermissoesGrupoConfiguracoesPretendentes();
      this.preencherPermissoesGrupoConfiguracoesCondominios();
      this.preencherPermissoesGrupoConfiguracoesAdministradoras();
      this.preencherPermissoesGrupoConfiguracoesUsuarios();
      this.preencherPermissoesGrupoConfiguracoesPerfis();
      this.preencherPermissoesGrupoConfiguracoesPlacas();
      this.preencherPermissoesGrupoConfiguracoesContas();
      this.preencherPermissoesGrupoConfiguracoesPortais();
      this.preencherPermissoesGrupoConfiguracoesLogs();
      this.preencherPermissoesGrupoConfiguracoesVisitas();
      this.preencherPermissoesGrupoConfiguracoesSistema();
    },

    preencherPermissoesGrupoAluguelClientes() {
      this.preencherGrupoPermissoes(this.moduloPermissoesClientesAluguel, GruposPermissoes.PERMISSOES_ALUGUEL_CLIENTES, this.grupoAluguelClientesChecklist);
    },
    preencherPermissoesGrupoAluguelBaixa() {
      this.preencherGrupoPermissoes(this.moduloPermissoesClientesAluguel, GruposPermissoes.PERMISSOES_ALUGUEL_BAIXA, this.grupoAluguelBaixaChecklist);
    },
    preencherPermissoesGrupoAluguelLiberacaoRepasse() {
      this.preencherGrupoPermissoes(this.moduloPermissoesClientesAluguel, GruposPermissoes.PERMISSOES_ALUGUEL_LIBERACAO_REPASSE, this.grupoAluguelLiberacaoRepasseChecklist);
    },
    preencherPermissoesGrupoAluguelImoveis() {
      this.preencherGrupoPermissoes(this.moduloPermissoesImoveisAluguel, GruposPermissoes.PERMISSOES_ALUGUEL_IMOVEIS, this.grupoAluguelImoveisChecklist);
    },
    preencherPermissoesGrupoAluguelContratos() {
      this.preencherGrupoPermissoes(this.moduloPermissoesContratosAluguel, GruposPermissoes.PERMISSOES_ALUGUEL_CONTRATOS, this.grupoAluguelContratosChecklist);
    },
    preencherPermissoesGrupoAluguelReajuste() {
      this.preencherGrupoPermissoes(this.moduloPermissoesContratosAluguel, GruposPermissoes.PERMISSOES_ALUGUEL_REAJUSTE, this.grupoAluguelReajusteChecklist);
    },
    preencherPermissoesGrupoAluguelVencimento() {
      this.preencherGrupoPermissoes(this.moduloPermissoesContratosAluguel, GruposPermissoes.PERMISSOES_ALUGUEL_VENCIMENTO, this.grupoAluguelVencimentoChecklist);
    },
    preencherPermissoesGrupoRelatoriosClientes() {
      this.moduloPermissoesRelatoriosClientesAluguel['visualizacao'] = this.grupoRelatoriosClientesChecklist.includes('visualizacao');
    },
    preencherPermissoesGrupoRelatoriosContratos() {
      this.preencherGrupoPermissoes(this.moduloPermissoesRelatoriosContratosAluguel, GruposPermissoes.PERMISSOES_RELATORIOS_CONTRATOS, this.grupoRelatoriosContratosChecklist);
    },
    preencherPermissoesGrupoRelatoriosImoveis() {
      this.preencherGrupoPermissoes(this.moduloPermissoesRelatoriosImoveisAluguel, GruposPermissoes.PERMISSOES_RELATORIOS_IMOVEIS, this.grupoRelatoriosImoveisChecklist);
    },
    preencherPermissoesGrupoRelatoriosPretendentes() {
      this.moduloPermissoesRelatoriosPretendentesAluguel['visualizacao'] = this.grupoRelatoriosPretendentesChecklist.includes('visualizacao');
    },
    preencherPermissoesGrupoRelatoriosFinanceiros() {
      this.preencherGrupoPermissoes(this.moduloPermissoesRelatoriosFinanceirosAluguel, GruposPermissoes.PERMISSOES_RELATORIOS_FINANCEIROS, this.grupoRelatoriosFinanceirosChecklist);
    },
    preencherPermissoesGrupoVendaClientes() {
      this.preencherGrupoPermissoes(this.moduloPermissoesClientesVenda, GruposPermissoes.PERMISSOES_VENDA_CLIENTES, this.grupoVendaClientesChecklist);
    },
    preencherPermissoesGrupoVendaImoveis() {
      this.preencherGrupoPermissoes(this.moduloPermissoesImoveisVenda, GruposPermissoes.PERMISSOES_VENDA_IMOVEIS, this.grupoVendaImoveisChecklist);
    },
    preencherPermissoesGrupoVendaContratos() {
      this.preencherGrupoPermissoes(this.moduloPermissoesContratosVenda, GruposPermissoes.PERMISSOES_VENDA_CONTRATOS, this.grupoVendaContratosChecklist);
    },
    preencherPermissoesGrupoVendaRelatorios() {
      this.moduloPermissoesRelatoriosCaptacoesVenda['visualizacao'] = this.grupoVendaRelatoriosChecklist.includes('captacoesVisualizacao');
      this.moduloPermissoesRelatoriosComissoesVenda['visualizacao'] = this.grupoVendaRelatoriosChecklist.includes('comissoesVisualizacao');
      this.moduloPermissoesRelatoriosComissoesVenda['visualizacaoSomenteComissoesCorretor'] = this.grupoVendaRelatoriosChecklist.includes('visualizacaoSomenteComissoesCorretor');
      this.moduloPermissoesRelatoriosClientesVenda['visualizacao'] = this.grupoVendaRelatoriosChecklist.includes('clientesVisualizacao');
      this.moduloPermissoesRelatoriosImoveisVenda['visualizacao'] = this.grupoVendaRelatoriosChecklist.includes('imoveisVisualizacao');
      this.moduloPermissoesRelatoriosPretendentesVenda['visualizacao'] = this.grupoVendaRelatoriosChecklist.includes('pretendentesVisualizacao');
    },
    preencherPermissoesGrupoFinanceiroContasReceber() {
      this.preencherGrupoPermissoes(this.moduloPermissoesContasReceber, GruposPermissoes.PERMISSOES_FINANCEIRO_CONTAS_RECEBER, this.grupoFinanceiroContasReceberChecklist);
    },
    preencherPermissoesGrupoFinanceiroLancamentosReceber() {
      this.preencherGrupoPermissoes(this.moduloPermissoesLancamentosContasReceber, GruposPermissoes.PERMISSOES_FINANCEIRO_LANCAMENTOS_RECEBER, this.grupoFinanceiroLancamentosReceberChecklist);
    },
    preencherPermissoesGrupoFinanceiroContasPagar() {
      this.preencherGrupoPermissoes(this.moduloPermissoesContasPagar, GruposPermissoes.PERMISSOES_FINANCEIRO_CONTAS_PAGAR, this.grupoFinanceiroContasPagarChecklist);
    },
    preencherPermissoesGrupoFinanceiroLancamentosPagar() {
      this.preencherGrupoPermissoes(this.moduloPermissoesLancamentosContasPagar, GruposPermissoes.PERMISSOES_FINANCEIRO_LANCAMENTOS_PAGAR, this.grupoFinanceiroLancamentosPagarChecklist);
    },
    preencherPermissoesGrupoFinanceiroCaixa() {
      this.preencherGrupoPermissoes(this.moduloPermissoesCaixa, GruposPermissoes.PERMISSOES_FINANCEIRO_CAIXA, this.grupoFinanceiroCaixaChecklist);
    },
    preencherPermissoesGrupoFinanceiroFornecedores() {
      this.preencherGrupoPermissoes(this.moduloPermissoesFornecedores, GruposPermissoes.PERMISSOES_FINANCEIRO_FORNECEDORES, this.grupoFinanceiroFornecedoresChecklist);
    },
    preencherPermissoesGrupoFinanceiroPlanosConta() {
      this.preencherGrupoPermissoes(this.moduloPermissoesPlanosConta, GruposPermissoes.PERMISSOES_FINANCEIRO_PLANOS_CONTA, this.grupoFinanceiroPlanosContaChecklist);
    },
    preencherPermissoesGrupoFinanceiroGruposConta() {
      this.preencherGrupoPermissoes(this.moduloPermissoesGruposConta, GruposPermissoes.PERMISSOES_FINANCEIRO_GRUPOS_CONTA, this.grupoFinanceiroGruposContaChecklist);
    },
    preencherPermissoesGrupoFinanceiroRelatorios() {
      this.moduloPermissoesContasPagar['relatorioContasPagas'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioContasPagas');
      this.moduloPermissoesContasPagar['relatorioContasAPagar'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioContasAPagar');
      this.moduloPermissoesContasPagar['relatorioContasAPagarVencidas'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioContasAPagarVencidas');
      this.moduloPermissoesContasReceber['relatorioContasRecebidas'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioContasRecebidas');
      this.moduloPermissoesContasReceber['relatorioContasAReceber'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioContasAReceber');
      this.moduloPermissoesContasReceber['relatorioContasAReceberVencidas'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioContasAReceberVencidas');
      this.moduloPermissoesContasReceber['relatorioCheques'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioCheques');
      this.moduloPermissoesContasReceber['relatorioRemessasGeradasFinanceiro'] = this.grupoFinanceiroRelatoriosChecklist.includes('relatorioRemessasGeradasFinanceiro');
    },
    preencherPermissoesGrupoConfiguracoesPretendentes() {
      this.preencherGrupoPermissoes(this.moduloPermissoesPretendentes, GruposPermissoes.PERMISSOES_CONFIGURACOES_PRETENDENTES, this.grupoConfiguracoesPretendentesChecklist);
    },
    preencherPermissoesGrupoConfiguracoesCondominios() {
      this.preencherGrupoPermissoes(this.moduloPermissoesCondominios, GruposPermissoes.PERMISSOES_CONFIGURACOES_CONDOMINIOS, this.grupoConfiguracoesCondominiosChecklist);
    },
    preencherPermissoesGrupoConfiguracoesAdministradoras() {
      this.preencherGrupoPermissoes(this.moduloPermissoesAdministradoras, GruposPermissoes.PERMISSOES_CONFIGURACOES_ADMINISTRADORAS, this.grupoConfiguracoesAdministradorasChecklist);
    },
    preencherPermissoesGrupoConfiguracoesUsuarios() {
      this.preencherGrupoPermissoes(this.moduloPermissoesUsuarios, GruposPermissoes.PERMISSOES_CONFIGURACOES_USUARIOS, this.grupoConfiguracoesUsuariosChecklist);
    },
    preencherPermissoesGrupoConfiguracoesPerfis() {
      this.preencherGrupoPermissoes(this.moduloPermissoesPerfisUsuarios, GruposPermissoes.PERMISSOES_CONFIGURACOES_PERFIS, this.grupoConfiguracoesPerfisChecklist);
    },
    preencherPermissoesGrupoConfiguracoesPlacas() {
      this.preencherGrupoPermissoes(this.moduloPermissoesPlacas, GruposPermissoes.PERMISSOES_CONFIGURACOES_PLACAS, this.grupoConfiguracoesPlacasChecklist);
    },
    preencherPermissoesGrupoConfiguracoesContas() {
      this.preencherGrupoPermissoes(this.moduloPermissoesContasBancarias, GruposPermissoes.PERMISSOES_CONFIGURACOES_CONTAS, this.grupoConfiguracoesContasChecklist);
    },
    preencherPermissoesGrupoConfiguracoesPortais() {
      this.preencherGrupoPermissoes(this.moduloPermissoesPortais, GruposPermissoes.PERMISSOES_CONFIGURACOES_PORTAIS, this.grupoConfiguracoesPortaisChecklist);
    },
    preencherPermissoesGrupoConfiguracoesLogs() {
      this.preencherGrupoPermissoes(this.moduloPermissoesLogs, GruposPermissoes.PERMISSOES_CONFIGURACOES_LOGS, this.grupoConfiguracoesLogsChecklist);
    },
    preencherPermissoesGrupoConfiguracoesVisitas() {
      this.preencherGrupoPermissoes(this.moduloPermissoesVisita, GruposPermissoes.PERMISSOES_CONFIGURACOES_VISITAS, this.grupoConfiguracoesVisitasChecklist);
    },
    preencherPermissoesGrupoConfiguracoesSistema() {
      this.preencherGrupoPermissoes(this.moduloPermissoesSistema, GruposPermissoes.PERMISSOES_CONFIGURACOES_SISTEMA, this.grupoConfiguracoesSistemaChecklist);
    },

    preencherGrupoPermissoes(modulo, permissoesGrupo, checkList) {
      for(let permissao of permissoesGrupo) {
        modulo[permissao] = checkList.includes(permissao);
      }
    },

    remover() {
      this.showLoading();

      this.removerUsuario(this.usuario)
        .then(this.handleResultadoRemoverUsuario)
        .catch(() => {
          this.$message.error('Não foi possível conectar-se ao servidor');
        }).finally(() => {
          this.hideLoading();
        });
    },

    handleResultadoRemoverUsuario(resultado) {
      switch(resultado.status) {
        case 'ERRO':
          this.$message.error(resultado.mensagem);
          break;

        case 'FALHA':
          this.exibirAlert('Atenção', resultado.mensagem, 'error');
          break;

        case 'SUCESSO':
          this.dispararPesquisa();
          this.$message.success(resultado.mensagem);
      }
    },

    selecionarTab(tab) {
      if(tab.name == 'permissoes') {
        this.handleRecuperarPerfis();
      }
    },

    handleRecuperarPerfis() {
      this.showLoading();

      this.listarPerfis({})
      .then(() => {
      }).catch(() => {
        this.$message('Erro ao conectar com o servidor')
      }).finally(() => {
        this.hideLoading();
      })
    },

    removerUsuarioHandler() {
      this.$confirm("Deseja realmente remover este Usuário?", "Atenção", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
          this.remover();
        }).catch(() => {});
    },
    selecaoContaBancariaHandler(conta) {
      this.contaBancariaSelecionada = conta;
    },
    removerContaBancariaHandler(conta) {
      this.$confirm('Deseja realmente remover esta Conta Bancária desse Usuário?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        let payload = conta;
        payload.usuario = { id: this.usuario.id };
        
        this.removerContaBancaria(payload);
      }).catch(() => {});
    },
    removerContaBancaria(conta) {
      this.showLoading();
      this.removerConta(conta)
        .then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
            case "FALHA":
              this.$message.warning(resultado.mensagem);
              break;
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    addHorarioAcesso() {
      if(!this.horarioAcesso.diaDaSemana) {
        this.$message.warning("Selecione um dia da semana");
        return;
      }
      if(!this.horarioAcesso.horarioInicio || !this.horarioAcesso.horarioFim) {
        this.$message.warning("Selecione um horário");
        return;
      }
      if(
        !Util.validarHora(this.horarioAcesso.horarioInicio) ||
        !Util.validarHora(this.horarioAcesso.horarioFim)
        ) {
          this.$message.warning("Selecione um horário válido");
          return;
        }
      if(!Util.validarIntervaloDeHora(this.horarioAcesso.horarioInicio, this.horarioAcesso.horarioFim)) {
        this.$message.warning("O horário inicial deve ser anterior ao horário final");
        return;
      }
      let payload = Object.assign({}, this.horarioAcesso);
      this.usuario.horariosDeAcesso.push(payload);
    },
    removerHorarioAcesso(horarioAcesso) {
      this.usuario.horariosDeAcesso = this.usuario.horariosDeAcesso
        .filter((item) => {
          return item != horarioAcesso;
        });
    },
    getLabelPerfilUsuario(perfil) {
      return Util.getLabel(PERFIS_USUARIO, perfil);
    },
  }
};